/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface CreateSubCategory$Params {
      body?: {
'Name'?: string;
'Description'?: string;
'CompanyId'?: string;
'ParentId'?: string;
'LanguageId'?: number;
'TaxRate'?: number;
'ImageFile'?: Blob;
}
}

export function createSubCategory(http: HttpClient, rootUrl: string, params?: CreateSubCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createSubCategory.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

createSubCategory.PATH = '/api/gmn/Menu/createsubcategory';
